import moment from 'moment';
import { UserDatasetRefreshLogDto, UserDatasetRefreshLogStageDto, UserDatasetRefreshReason, UserDatasetRefreshStageType, UserDatasetRefreshStatus } from 'src/app/services/api.services';
import { UserDatasetRefreshModalState } from '../../refresh-userdataset-progress-dialog/refresh-userdataset-progress-dialog.component';

export interface SettingsRefreshDetails {
  DetailsReady: boolean;
  LastRefreshed: string;
  LastRefreshedBy: string;
  RefreshDuration: string;
  LongDuration: boolean;
  ConnectionTime: string;
  ExecutionTime: string;
  DataTransferTime: string;
  FinalPreparationTime: string;
}

export function refreshLogToFormatedDetails(userDatasetLastRefreshLog: UserDatasetRefreshLogDto) {
  let settingRefreshDetails = <SettingsRefreshDetails>{DetailsReady: false};

  if (!userDatasetLastRefreshLog || userDatasetLastRefreshLog.status != UserDatasetRefreshStatus.Succeeded)
    return settingRefreshDetails;

  settingRefreshDetails.LastRefreshed = userDatasetLastRefreshLog.finishedDateTimeUTC;

  if (userDatasetLastRefreshLog.legacy) {
    settingRefreshDetails.DetailsReady = true;
    return settingRefreshDetails;
  }

  switch (userDatasetLastRefreshLog.requestReason) {
    case UserDatasetRefreshReason.ByUser:
      settingRefreshDetails.LastRefreshedBy = userDatasetLastRefreshLog.requestedBy.username;
      break;

    case UserDatasetRefreshReason.ByAPIExport:
      settingRefreshDetails.LastRefreshedBy = 'API Call';
      break;

    case UserDatasetRefreshReason.Schedule:
      settingRefreshDetails.LastRefreshedBy = 'Scheduled Report';
      break;
  }

  let started = moment(userDatasetLastRefreshLog.requestDateTimeUTC);
  let finished = moment(userDatasetLastRefreshLog.finishedDateTimeUTC);

  const refreshDuration = moment.duration(finished.diff(started));

  const DatasetOperations = userDatasetLastRefreshLog.stages.filter((s) => s.type == UserDatasetRefreshStageType.DatasetDataLoad);

  const stageDurations = getStageDurations(userDatasetLastRefreshLog, DatasetOperations);

  const connectionTime = moment.duration(stageDurations[UserDatasetRefreshModalState.Connecting]);
  const executionTime = moment.duration(stageDurations[UserDatasetRefreshModalState.Execution]);
  const dataTransferTime = moment.duration(stageDurations[UserDatasetRefreshModalState.DataTransfer]);

  const finalStage = userDatasetLastRefreshLog.stages.find((s) => s.type == UserDatasetRefreshStageType.Finalization);

  started = moment(finalStage.startedDateTimeUTC);
  finished = moment(userDatasetLastRefreshLog.finishedDateTimeUTC);
  const finalPreparationTime = moment.duration(finished.diff(started));

  let longDuration = 
    [refreshDuration, connectionTime, executionTime, dataTransferTime, finalPreparationTime].filter((d) => d.asMinutes() >= 60).length > 0;

  settingRefreshDetails.LongDuration = longDuration;

  settingRefreshDetails.RefreshDuration = durationToTimeString(refreshDuration, longDuration);

  settingRefreshDetails.ConnectionTime = durationToTimeString(connectionTime, longDuration);
  settingRefreshDetails.ExecutionTime = durationToTimeString(executionTime, longDuration);
  settingRefreshDetails.DataTransferTime = durationToTimeString(dataTransferTime, longDuration);

  settingRefreshDetails.FinalPreparationTime = durationToTimeString(finalPreparationTime, longDuration);

  settingRefreshDetails.DetailsReady = true;

  return settingRefreshDetails;
}

function getStageDurations(userDatasetLastRefreshLog: UserDatasetRefreshLogDto, DatasetOperations: UserDatasetRefreshLogStageDto[]) {
  // There are currently 3 Sub stages
  const stageDurations: number[] = new Array<number>(3);

  // For Each Dataset we calculate the time its sub stages took we then collect the longest time Each Sub stage took
  for (const DatasetStage of DatasetOperations) {
    // Get the time each sub stage took in this Dataset
    for (let subStageIndex = 0; subStageIndex < DatasetStage.substages.length; subStageIndex++) {
      let started: moment.Moment;
      if (subStageIndex == UserDatasetRefreshModalState.Connecting) {
        started = moment(userDatasetLastRefreshLog.requestDateTimeUTC);
      } else {
        started = moment(DatasetStage.substages[subStageIndex].startedDateTimeUTC);
      }

      const finished = moment(DatasetStage.substages[subStageIndex].finishedDateTimeUTC);
      const duration = finished.diff(started);

      if (stageDurations[subStageIndex] == null) stageDurations[subStageIndex] = duration;

      // Return only the longest overall duration of this sub stage
      stageDurations[subStageIndex] = Math.max(stageDurations[subStageIndex], duration);
    }
  }

  return stageDurations;
}

function durationToTimeString(duration: moment.Duration, long: boolean) {
  const seconds = duration.seconds().toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false });
  const minutes = duration.minutes().toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false });
  const hours = duration.hours().toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false });

  //if any of the durations are longer than mm:ss can display we switch to hh:mm:ss
  if (long) {
    return `${hours}:${minutes}:${seconds}`;
  }
  return `${minutes}:${seconds}`;
}
